import {AsyncPipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger,} from '@angular/material/autocomplete';
import {MatOption} from '@angular/material/core';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {ActivatedRoute, Router} from '@angular/router';
import {AutocompleteResults, AutocompleteService} from '@app/assetfilter/autocomplete.service';
import {FilterService, kAfterRegex, kBeforeRegex} from '@app/assetfilter/filter.service';
import {User} from '@app/shared/user.service';
import {StateService} from '@app/state/state.service';

import {Tag} from '@app/tag/models';
import {FilterQuery} from '@app/tag/tag-input/tag-input.component';
import {Observable, of} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';

@Component({
    selector: 'frog-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [
        MatInput,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatAutocomplete,
        MatOption,
        MatIcon,
        AsyncPipe,
    ],
})
export class SearchComponent implements OnInit {
    @ViewChild('input') input;
    public queryControl: UntypedFormControl;
    public results$: Observable<AutocompleteResults>;
    private readonly actionPrefix: string = 'Search';

    constructor(
        private filterService: FilterService,
        private stateService: StateService,
        private autocompleteService: AutocompleteService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
        this.queryControl = new UntypedFormControl();
    }

    ngOnInit(): void {
        this.results$ = this.autocompleteService.autocomplete('').pipe(
            mergeMap(() => {
                return this.queryControl.valueChanges;
            }),
            // debounceTime(150),
            mergeMap((value) => {
                if (typeof value === 'string') {
                    return this.autocompleteService.autocomplete(value.toLocaleLowerCase());
                }
                return of(new AutocompleteResults([], []));
            }),
            map((results) => {
                if (this.queryControl.value) {
                    const actionTag = new Tag();
                    actionTag.id = null;
                    actionTag.name = `${this.actionPrefix} ${this.queryControl.value}`;
                    results.tags.splice(0, 0, actionTag);
                }

                return results;
            }),
        );
    }

    clear() {
        this.queryControl.reset();
    }

    selectHandler(event: MatAutocompleteSelectedEvent) {
        this.emitSelect(event.option.value);
    }

    displayName() {
        return (tag) => (tag ? tag.displayName : null);
    }

    private emitSelect(value: Tag | User) {
        const filterQuery = new FilterQuery();
        if (Object.keys(value).includes('email')) {
            filterQuery.value = (value as User).email;
            filterQuery.user = true;
        } else {
            if (value.id === null) {
                const queryValue = this.queryControl.value.name.replace(
                    `${this.actionPrefix} `,
                    '',
                );
                filterQuery.value = queryValue;
                if (kAfterRegex.test(queryValue) || kBeforeRegex.test(queryValue)) {
                    filterQuery.date = true;
                } else {
                    filterQuery.search = true;
                }
            } else {
                filterQuery.value = value.name;
                filterQuery.search = false;
            }
        }

        this.applyTag(filterQuery);
        this.queryControl.setValue('');
    }

    applyTag(filterQuery: FilterQuery) {
        this.filterService.setFilterQuery(filterQuery);
    }
}
